import { render } from "preact";
import { App } from "./app";
import { BRAND } from "./config";
import "./styles.css";

// Apply the active brand's accent colors over the :root defaults in styles.css.
const docEl = document.documentElement;
docEl.style.setProperty("--bbg-green", BRAND.theme.primary);
docEl.style.setProperty("--bbg-green-dark", BRAND.theme.primaryDark);
document.title = `Book Your ${BRAND.consultIsFree ? "Free " : ""}Consult - ${BRAND.name}`;

// The build injects a crawler-visible static block (AI crawlers don't run JS);
// the live app replaces it.
document.getElementById("bbg-static")?.remove();

const root = document.getElementById("bbg-root");
if (root) render(<App />, root);
